var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-block",class:{ selected: _vm.selected },style:({ textAlign: _vm.block.align || 'left' })},[_c('a',{style:(_vm.aStyle),attrs:{"href":_vm.block.href || '#'},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(" "+_vm._s(_vm.block.label || "Button")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }